<template>
  <div>
    <div class="panel">
      <div class="header">推演参数</div>
      <div class="body">
        <div class="label" style="margin: 10px 0;">
          <span>工况</span>
          <span class="extra">（短历时：120分钟，长历时：24小时）</span>
        </div>

          <div class="filter-bar">
              <div class="filter-group">
                  <select class="filter-select" v-model="selectedCategory">
                      <option value="">-请选择-</option>
                      <option  v-for="(item, index) in categorySelectList" :key="index" :value="item">{{ item }}</option>
                  </select>
              </div>
          </div>

        <div class="label">水动力参数</div>
        <div class="field">
          <a-radio-group v-model="selectedSubType">
            <a-radio style="display: block" v-for="(item, index) in subTypeList1" :key="index" :value="item.value">
              <span>
                {{ item.label }}
              </span>
            </a-radio>
          </a-radio-group>
        </div>

        <div class="label">雨水排口及截污总管水质</div>
        <div class="field">
          <a-radio-group v-model="selectedSubType">
            <a-radio :style="{
              display: 'block',
            }" v-for="(item, index) in subTypeList2" :key="index" :value="item.value">
              <span>
                {{ item.label }}
              </span>
            </a-radio>
          </a-radio-group>
        </div>

        <div class="scale" v-if="selectedSubType && colorList.find((item) => item.type === selectedSubType) ">
          <div v-for="(item, index) in colorList.find( (item) => item.type === selectedSubType ).list" :key="index" class="item">
            <div class="color" :style="{ background: item.color }"></div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="tool" v-if="selectedSubType === 'ds_vel' ||
      selectedSubType === 'node_depnod' ||
      selectedSubType === 'depth2d'
      ">
      <div class="icon" @click="play" style="margin-right: 1em">
        <a-icon v-if="isPlay" type="pause-circle" />
        <a-icon v-else type="play-circle" />
      </div>

      <template v-if="dateList.length">
        <!-- <DatePicker
          :dateList="dateList"
          :activeIndex="activeDateIndex"
          @setActiveIndex="(idx) => (activeDateIndex = idx)"
        /> -->
        <template v-if="dateList[activeDateIndex].timeList.length > 1">
          <a-slider style="width: 100%" v-model="activeTimeIndex" :tooltip-visible="true"
            :tipFormatter="(idx) => dateList[activeDateIndex].timeList[idx]"
            :max="dateList[activeDateIndex].timeList.length - 1" />
        </template>
      </template>
    </div>

    <AbilityType v-if="selectedSubType === 'hydro_link_ability'" />

    <!--右上角统计数据卡片-->
    <div v-if="selectedSubType === 'ds_vel'" class="top-right-alert-card">
      <div class="alert-card">工况: {{ selectedCategory }}
        <div>流速小于5cm/s</div>
        <div>管道总长度：<span>{{ ds_vel_alert_cache.length }} km</span></div>
        <div>管道占比：<span>{{ ds_vel_alert_cache.percentage }} %</span></div>
      </div>
    </div>

    <div v-if="selectedSubType === 'depth2d'" class="top-right-alert-card">
      <div class="alert-card">工况: {{ selectedCategory }}
        <div>易涝区统计：</div>
        <div>0.15-0.3m: <span>{{ depth2d_alert_cache['range0.15-0.3'] }} 个</span></div>
        <div>0.3-0.5m: <span>{{ depth2d_alert_cache['range0.3-0.5'] }} 个</span></div>
        <div>>0.5m: <span>{{ depth2d_alert_cache['range0.5'] }} 个</span></div>
      </div>
    </div>
    <!--显示图例-->
    <div v-if="selectedSubType === 'hydro_rr_tph' || selectedSubType === 'hydro_rr_nh4' || selectedSubType === 'hydro_rr_cod' || selectedSubType === 'hydro_ds_flow'"
      class="left-bottom-card">
      <div class="alert-card">图例
        <div><img src="~@/assets/model/截流总管.png" /> 截流总管</div>
        <div><img src="~@/assets/model/排口.png" /> 排口</div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/api/request";
import AbilityType from "./components/ability-type.vue";

// import DatePicker from "./components/date-picker.vue";
import { debounce } from "lodash";

import { mapActions, mapMutations, mapState } from "vuex";

function fetchCategory() {
  return request({
    url: "/model-analysis/hydro/category/list",
  });
}
function fetchTimeList({ type }) {
  return request({
    url: "/model-analysis/hydro/timerange/" + type,
  });
}

/**2023.6.12 水动力模型新增
 * 
 */
function fetchAlert(ts, type) {
  return request({
    url: "/model-analysis/hydro/alert",
    method: 'post',
    data: {
      type: type,
      ts: ts
    }
  })
}

export default {
  components: {
    // DatePicker,
    AbilityType,
  },

  data() {
    return {
      list: [], // 流速

      selectedCategory: "",
      categoryList: [],
      categorySelectList: [],

      selectedSubType: null,

      subTypeList1: [
        {
          label: "流速",
          value: "ds_vel",
        },
        // {
        //   label: "水位",
        //   value: "node_depnod",
        // },
        {
          label: "流量",
          value: "hydro_ds_flow",
        },
        {
          label: "管道能力",
          value: "hydro_link_ability",
        },
        {
          label: "易涝区",
          value: "depth2d",
        },
      ],
      subTypeList2: [
        {
          label: "总磷",
          value: "hydro_rr_tph",
        },
        {
          label: "氨氮",
          value: "hydro_rr_nh4",
        },
        {
          label: "化学需氧量",
          value: "hydro_rr_cod",
        },
      ],

      colorList: [
        {
          label: "流速",
          type: "ds_vel",
          list: [
            {
              color: "#f00",
              value: "<5cm/s",
            },
            {
              color: "#080",
              value: "<10cm/s",
            },
            {
              color: "#87CEFA",
              value: "<20cm/s",
            },
            {
              color: "#00f",
              value: ">=20cm/s",
            },
          ],
        },

        {
          label: "水位",
          type: "node_depnod",
          list: [
            {
              color: "#66CCFF",
              value: "<110m",
            },
            {
              color: "#3399FF",
              value: "110-125m",
            },
            {
              color: "#0066FF",
              value: "125-140m",
            },
            {
              color: "#0033FF",
              value: ">140m",
            },
          ],
        },

        {
          label: "管道能力",
          type: "hydro_link_ability",
          list: [
            {
              color: "#ee7b34",
              value: "1-3年一遇",
            },
            {
              color: "#3e8629",
              value: "3-5年一遇",
            },
            {
              color: "#3b83f7",
              value: "5-10年一遇",
            },
            {
              color: "#0c0cf5",
              value: ">10年一遇",
            },
            {
              color: "#ea3324",
              value: "不足1年一遇",
            },
          ],
        },

        {
          label: "易涝区",
          type: "depth2d",
          list: [
            {
              color: "red",
              value: ">0.5m",
            },
            {
              color: "orange",
              value: "0.3-0.5m",
            },
            {
              color: "gold",
              value: "0.15-0.3m",
            },
          ],
        },
      ],

      dateList: [],
      activeDateIndex: null,
      activeTimeIndex: null,

      isPlay: false,

      timeList: [],

      //
      depth2d_alert_cache: {},
      ds_vel_alert_cache: {}
    };
  },

  computed: {
    activeDate() {
      if (this.dateList.length > 0) {
        return this.dateList[this.activeDateIndex].date;
      } else {
        return null;
      }
    },
    activeTime() {
      if (this.dateList.length > 0) {
        return this.dateList[this.activeDateIndex].timeList[
          this.activeTimeIndex
        ];
      } else {
        return null;
      }
    },

    ...mapState("map", [
      "activeRehearsalWaterId",
      "rehearsalWaterVisible",
      "flowId",
      "flowVisible",
    ]),
  },

  watch: {
    selectedSubType() {
      this.setClearMap();
      this.getDate();
    },

    // 用户切换日期，改变时间选中
    activeDateIndex() {
      this.activeTimeIndex = 0;
    },
    activeTimeIndex() {
      this.debouncedRefreshData();
    },
  },

  mounted() {
    this.setClearMap();

    this.debouncedRefreshData = debounce(this.refreshData, 500);

    fetchCategory().then((res) => {
      console.log("category", res);
      if (Array.isArray(res)) {
        this.categoryList = res;
        this.categorySelectList = res
          .map((item) => item.duration + "-" + item.condition)
          .filter((item, index, self) => self.indexOf(item) === index);
        if (res.length > 0) {
          this.selectedCategory = this.categorySelectList[0];

          this.selectedSubType = "ds_vel";
          // this.selectedSubType = "hydro_rr_tph";
        }
      }
    });
  },

  methods: {
    ...mapActions("map", ["getRehearsalList"]),
    ...mapMutations("map", ["setClearMap"]),

    // 切换日期和时间刷新数据
    refreshData() {
      if (this.activeDate && this.activeTime) {
        if (this.selectedSubType) {
          // 默认加载当前选中的
          this.getList(this.selectedSubType);
          this.getAlertInfo()
        }

      }
    },

    play() {
      this.isPlay = !this.isPlay;

      if (this.isPlay) {
        this.timer = setInterval(() => {
          if (this.dateList.length > this.activeDateIndex) {
            const timeListLength =
              this.dateList[this.activeDateIndex].timeList.length;
            if (timeListLength > this.activeTimeIndex) {
              if (this.activeTimeIndex === timeListLength - 1) {
                // 最后一个时间节点
                this.activeTimeIndex = 0;
                if (this.activeDateIndex === this.dateList.length - 1) {
                  this.activeDateIndex = 0;
                } else {
                  this.activeDateIndex++;
                }
              } else {
                this.activeTimeIndex++;
              }
            }
          }
        }, 3000);
        this.$once("hook:beforeDestroy", () => {
          if (this.timer) {
            clearInterval(this.timer);
          }
        });
      } else {
        if (this.timer) {
          clearInterval(this.timer);
        }
      }
    },

    getDate() {
      const hide = this.$message.loading("加载中...");
      fetchTimeList({
        type: this.selectedSubType,
      })
        .then((res) => {
          if (Array.isArray(res)) {
            const dateList = [];
            res.forEach((item) => {
              if (typeof item === "string") {
                const arr = item.split(" ");
                if (arr.length === 2) {
                  const index = dateList.findIndex(
                    (dateObj) => dateObj.date === arr[0]
                  );
                  if (index > -1) {
                    dateList[index].timeList.push(arr[1]);
                  } else {
                    dateList.push({
                      date: arr[0],
                      timeList: [arr[1]],
                    });
                  }
                }
              }
            });
            if (dateList.length > 0) {
              this.dateList = dateList;

              if (this.activeDateIndex !== 0) {
                this.activeDateIndex = 0;
              } else {
                this.getList(this.selectedSubType);
              }
            }
          }
        })
        .finally(() => {
          hide();
        });
    },

    setActive(item, element) {
      this.activeDate = item;
      this.activeTime = element;

      this.getList(this.selectedSubType);
    },

    getList(type) {
      if (type === "hydro_link_ability") {
        this.getRehearsalList({
          type,
        });


        return;
      }

      if (type === "ds_vel") {
        this.getList("node_depnod");

      }

      const item = this.categoryList.find(
        (item) =>
          this.selectedCategory === item.duration + "-" + item.condition &&
          item.type === type
      );

      const flow = this.categoryList.find(
        (item) =>
          this.selectedCategory === item.duration + "-" + item.condition &&
          item.type === "rainfall"
      );

      this.getRehearsalList({
        ts: this.activeDate + " " + this.activeTime,
        type,
        pid: item ? item.id : "",
        flow,
      });
    },

    getAlertInfo() {
      const ts = this.activeDate + " " + this.activeTime
      const ds_vel = 'ds_vel'
      const depth2d = 'depth2d'
      // 先获取流速

      if (this.selectedSubType === 'ds_vel') {
        fetchAlert(ts, ds_vel).then((res) => {
          //console.log('ds_vel')
          //console.log(res)
          this.ds_vel_alert_cache = res
        })
      }
      if (this.selectedSubType === 'depth2d') {
        // 获取易捞区
        fetchAlert(ts, depth2d).then((res) => {
          //console.log('depth2d')
          //console.log(res)
          this.depth2d_alert_cache = res
        })
      }
    }
  },
};
</script>
<style lang='less' scoped>
.panel {
  position: fixed;
  top: 10vh;
  left: 12px;
  bottom: 64px;
  width: 280px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  background-color: var(--detail-bgcolor);
  .header {
    color: #00ff96;
    padding: 8px 12px;
    font-weight: bold;
    font-size: 16px;
  }

  .body {
    flex: 1;
    display: flex;
    flex-direction: column;
    .label {
      //background-color: var(--default-bgcolor);
      padding-left: 12px;
      padding-right: 12px;
      display: flex;
      align-items: center;
      color: #5cc59a;
      &>span:first-child {
        font-weight: bold;
        color: #fff;
      }
      &>span:last-child {
        font-size: 12px;
        color: #d9d9d9;
      }
    }
    .field {
      //background-color: var(--default-bgcolor);
      padding: 8px 12px;
    }
  }
}

.tool {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  padding: 12px;
  background-color: var(--default-bgcolor);
  display: flex;
  align-items: center;
}

.top-right-alert-card {
  position: fixed;
  top: 10%;
  right: 20px;
  z-index: 101;
  padding: 12px;
  background-color: var(--default-bgcolor);
  display: flex;
  align-items: center;
  color:#b9b9b9;
}

.alert-card {
  display: flex;
  flex-direction: column;
  text-align: center;

  div {
    display: flex;
    justify-content: space-between;
    margin-top: 10%;
    align-items: center;

    img {
      max-width: 36px;
      margin-right: 12px;
    }
  }
}

.icon {
  color: #67927f;
  font-size: 28px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.control {
  position: fixed;
  top: 10vh;
  right: 1.5vw;
  z-index: 99;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.scale {
  background-color: var(--default-bgcolor);
  margin-top: auto;
  display: grid;
  font-size: 12px;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 12px;
  color:#fff;
  .item {
    display: flex;
    align-items: center;
  }

  .color {
    height: 16px;
    width: 8px;
    margin-right: 8px;
  }
}

.left-bottom-card {
  position: fixed;
  bottom: 10%;
  left: 12px;
  z-index: 101;
  padding: 12px;
  background-color: var(--default-bgcolor);
  display: flex;
  align-items: center;
  color:#fff;
  width:280px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width:100%;
  justify-content: center;
}

.filter-select {
  padding: 0.5rem 1rem;
  background: rgb(0 0 0 / 60%);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 90%;
}

.filter-select:focus {
  outline: none;
  border-color: #00ff96;
  box-shadow: 0 0 10px rgba(0, 255, 150, 0.2);
}

::v-deep .ant-radio-wrapper{
  color: #b9b9b9;
  margin:10px;
}
.filter-bar{
  margin:10px 0;
}
</style>